import React, { useMemo } from 'react';
import {
  IntegrationsPageLayout,
  IntegrationsPageLayoutProps,
} from 'components/Integrations/components/IntegrationsPageLayout';

export interface GruntworxPageLayoutProps extends IntegrationsPageLayoutProps {}

export const GruntworxPageLayout = ({
  pageTitle = 'GruntWorx Integration',
  breadcrumbs: additionalBreadcrumbs = [],
  ...rest
}: GruntworxPageLayoutProps) => {
  const breadcrumbs = useMemo(
    () => [{ path: '/gruntworx', label: 'GruntWorx' }, ...additionalBreadcrumbs],
    [additionalBreadcrumbs],
  );
  return (
    <IntegrationsPageLayout
      {...rest}
      pageTitle={pageTitle}
      breadcrumbs={breadcrumbs}
    />
  );
}; 